import { useCallback, useState } from 'react';
import { Outlet } from 'react-router-dom';

import { cn } from '~/lib/cn';
import { GlobalSearch } from '~/modules/global-search/GlobalSearch.tsx';

export const GlobalSearchWrapper = () => {
  const [isSearchResultVisible, setIsSearchResultVisible] = useState(false);

  const handleSearchChange = useCallback((value: string) => {
    setIsSearchResultVisible(Boolean(value));
  }, []);

  return (
    <div className="flex flex-col flex-1 h-dvh">
      <GlobalSearch onChange={handleSearchChange} />
      <div className="flex flex-1 flex-col overflow-hidden relative">
        <div
          className={cn(
            'absolute z-10 top-0 bottom-0 right-0 left-0 backdrop-blur-lg transition transition-100',
            !isSearchResultVisible && 'hidden',
          )}
        />
        <Outlet />
      </div>
    </div>
  );
};

GlobalSearchWrapper.displayName = 'GlobalSearchWrapper';
